import PropTypes from "prop-types";

export const reconciliationItemShape = PropTypes.shape({
  openBalance: PropTypes.number,
  allocation: PropTypes.number,
  transferredIn: PropTypes.number,
  transferredOut: PropTypes.number,
  interestEarned: PropTypes.number,
  proceedsFromDisposal: PropTypes.number,
  closeBalance: PropTypes.number,
  airport: PropTypes.number,
  broadband: PropTypes.number,
  brownfield: PropTypes.number,
  capacityBldg: PropTypes.number,
  commEnergy: PropTypes.number,
  culture: PropTypes.number,
  disaster: PropTypes.number,
  fireStation: PropTypes.number,
  recreation: PropTypes.number,
  roadsBridges: PropTypes.number,
  shortline: PropTypes.number,
  shortsea: PropTypes.number,
  solidWaste: PropTypes.number,
  sport: PropTypes.number,
  transit: PropTypes.number,
  tourism: PropTypes.number,
  wastewater: PropTypes.number,
  water: PropTypes.number,
  netRevenues: PropTypes.number,
  netTransfers: PropTypes.number,
  netExpenditures: PropTypes.number,
});
